import { render, staticRenderFns } from "./updateBuy.vue?vue&type=template&id=4c03ede6&scoped=true"
import script from "./updateBuy.vue?vue&type=script&lang=js"
export * from "./updateBuy.vue?vue&type=script&lang=js"
import style0 from "./updateBuy.vue?vue&type=style&index=0&id=4c03ede6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c03ede6",
  null
  
)

export default component.exports